import { render, staticRenderFns } from "./PatientPanelSection.vue?vue&type=template&id=a7d0ac98&scoped=true&lang=pug&"
import script from "./PatientPanelSection.vue?vue&type=script&lang=js&"
export * from "./PatientPanelSection.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a7d0ac98",
  null
  
)

export default component.exports